/** AI Segmentation model: Auto (member→Large) | Small (trial) | Large (full). */

export const SUBTITLE_OPTIMIZE_MODELS = ['auto', 'small', 'large'] as const;
export type SubtitleOptimizeModel = (typeof SUBTITLE_OPTIMIZE_MODELS)[number];

export type EnhanceEndpointChoice = 'v' | 'v4' | 'member_only';

export function normalizeSubtitleOptimizeModel(
  raw: unknown,
): SubtitleOptimizeModel {
  if (raw === 'large') return 'large';
  if (raw === 'small') return 'small';
  return 'auto';
}

/**
 * Map UI model + membership to enhance endpoint.
 * - auto → full (`v`) for members, trial (`v4`) for non-members
 * - small → trial (`v4`) for everyone
 * - large → full (`v`) for members; `member_only` for non-members (no createJob)
 */
export function resolveEnhanceEndpoint(
  model: SubtitleOptimizeModel | string | undefined,
  isMember: boolean,
): EnhanceEndpointChoice {
  const m = normalizeSubtitleOptimizeModel(model);
  if (m === 'small') return 'v4';
  if (m === 'auto') return isMember ? 'v' : 'v4';
  return isMember ? 'v' : 'member_only';
}
